var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12",staticStyle:{"min-height":"400px","padding-bottom":"60px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }